// Country codes for phone numbers - Complete list with country abbreviations
// Helper function to get country abbreviation from country code
const getCountryAbbr = (code) => {
  const abbrMap = {
    '+1': 'US/CA',
    '+7': 'RU/KZ',
    '+20': 'EG',
    '+27': 'ZA',
    '+30': 'GR',
    '+31': 'NL',
    '+32': 'BE',
    '+33': 'FR',
    '+34': 'ES',
    '+36': 'HU',
    '+39': 'IT',
    '+40': 'RO',
    '+41': 'CH',
    '+43': 'AT',
    '+44': 'GB',
    '+45': 'DK',
    '+46': 'SE',
    '+47': 'NO',
    '+48': 'PL',
    '+49': 'DE',
    '+51': 'PE',
    '+52': 'MX',
    '+53': 'CU',
    '+54': 'AR',
    '+55': 'BR',
    '+56': 'CL',
    '+57': 'CO',
    '+58': 'VE',
    '+60': 'MY',
    '+61': 'AU',
    '+62': 'ID',
    '+63': 'PH',
    '+64': 'NZ',
    '+65': 'SG',
    '+66': 'TH',
    '+81': 'JP',
    '+82': 'KR',
    '+84': 'VN',
    '+86': 'CN',
    '+90': 'TR',
    '+91': 'IN',
    '+92': 'PK',
    '+93': 'AF',
    '+94': 'LK',
    '+95': 'MM',
    '+212': 'MA',
    '+213': 'DZ',
    '+216': 'TN',
    '+218': 'LY',
    '+220': 'GM',
    '+221': 'SN',
    '+222': 'MR',
    '+223': 'ML',
    '+224': 'GN',
    '+225': 'CI',
    '+226': 'BF',
    '+227': 'NE',
    '+228': 'TG',
    '+229': 'BJ',
    '+230': 'MU',
    '+231': 'LR',
    '+232': 'SL',
    '+233': 'GH',
    '+234': 'NG',
    '+235': 'TD',
    '+236': 'CF',
    '+237': 'CM',
    '+238': 'CV',
    '+239': 'ST',
    '+240': 'GQ',
    '+241': 'GA',
    '+242': 'CG',
    '+243': 'CD',
    '+244': 'AO',
    '+245': 'GW',
    '+248': 'SC',
    '+249': 'SD',
    '+250': 'RW',
    '+251': 'ET',
    '+252': 'SO',
    '+253': 'DJ',
    '+254': 'KE',
    '+255': 'TZ',
    '+256': 'UG',
    '+257': 'BI',
    '+258': 'MZ',
    '+260': 'ZM',
    '+261': 'MG',
    '+262': 'RE',
    '+263': 'ZW',
    '+264': 'NA',
    '+265': 'MW',
    '+266': 'LS',
    '+267': 'BW',
    '+268': 'SZ',
    '+269': 'KM',
    '+291': 'ER',
    '+297': 'AW',
    '+298': 'FO',
    '+299': 'GL',
    '+350': 'GI',
    '+351': 'PT',
    '+352': 'LU',
    '+353': 'IE',
    '+354': 'IS',
    '+355': 'AL',
    '+356': 'MT',
    '+357': 'CY',
    '+358': 'FI',
    '+359': 'BG',
    '+370': 'LT',
    '+371': 'LV',
    '+372': 'EE',
    '+373': 'MD',
    '+374': 'AM',
    '+375': 'BY',
    '+376': 'AD',
    '+377': 'MC',
    '+378': 'SM',
    '+380': 'UA',
    '+381': 'RS',
    '+382': 'ME',
    '+383': 'XK',
    '+385': 'HR',
    '+386': 'SI',
    '+387': 'BA',
    '+389': 'MK',
    '+420': 'CZ',
    '+421': 'SK',
    '+423': 'LI',
    '+500': 'FK',
    '+501': 'BZ',
    '+502': 'GT',
    '+503': 'SV',
    '+504': 'HN',
    '+505': 'NI',
    '+506': 'CR',
    '+507': 'PA',
    '+509': 'HT',
    '+590': 'GP',
    '+591': 'BO',
    '+592': 'GY',
    '+593': 'EC',
    '+594': 'GF',
    '+595': 'PY',
    '+596': 'MQ',
    '+597': 'SR',
    '+598': 'UY',
    '+599': 'CW',
    '+670': 'TL',
    '+672': 'AQ',
    '+673': 'BN',
    '+674': 'NR',
    '+675': 'PG',
    '+676': 'TO',
    '+677': 'SB',
    '+678': 'VU',
    '+679': 'FJ',
    '+680': 'PW',
    '+681': 'WF',
    '+682': 'CK',
    '+685': 'WS',
    '+686': 'KI',
    '+687': 'NC',
    '+688': 'TV',
    '+689': 'PF',
    '+691': 'FM',
    '+692': 'MH',
    '+850': 'KP',
    '+852': 'HK',
    '+853': 'MO',
    '+855': 'KH',
    '+856': 'LA',
    '+880': 'BD',
    '+886': 'TW',
    '+960': 'MV',
    '+961': 'LB',
    '+962': 'JO',
    '+963': 'SY',
    '+964': 'IQ',
    '+965': 'KW',
    '+966': 'SA',
    '+967': 'YE',
    '+968': 'OM',
    '+970': 'PS',
    '+971': 'AE',
    '+972': 'IL',
    '+973': 'BH',
    '+974': 'QA',
    '+975': 'BT',
    '+976': 'MN',
    '+977': 'NP',
    '+992': 'TJ',
    '+993': 'TM',
    '+994': 'AZ',
    '+995': 'GE',
    '+996': 'KG',
    '+998': 'UZ',
  };
  return abbrMap[code] || '';
};

// Create country code entries with abbreviations
const createCountryCode = (value, labelEn, labelAr) => {
  const abbr = getCountryAbbr(value);
  // Replace country name with abbreviation in format: +974 (Qatar) -> +974 (QA)
  const labelWithAbbr = labelEn.replace(/\([^)]+\)/, `(${abbr})`);
  const labelArWithAbbr = labelAr.replace(/\([^)]+\)/, `(${abbr})`);
  return {
    value,
    label: labelWithAbbr,
    labelAr: labelArWithAbbr,
  };
};

export const COUNTRY_CODES = [
  createCountryCode('+1', '+1 (US/Canada)', '+1 (الولايات المتحدة/كندا)'),
  createCountryCode('+7', '+7 (Russia/Kazakhstan)', '+7 (روسيا/كازاخستان)'),
  createCountryCode('+20', '+20 (Egypt)', '+20 (مصر)'),
  createCountryCode('+27', '+27 (South Africa)', '+27 (جنوب أفريقيا)'),
  createCountryCode('+30', '+30 (Greece)', '+30 (اليونان)'),
  createCountryCode('+31', '+31 (Netherlands)', '+31 (هولندا)'),
  createCountryCode('+32', '+32 (Belgium)', '+32 (بلجيكا)'),
  createCountryCode('+33', '+33 (France)', '+33 (فرنسا)'),
  createCountryCode('+34', '+34 (Spain)', '+34 (إسبانيا)'),
  createCountryCode('+36', '+36 (Hungary)', '+36 (المجر)'),
  createCountryCode('+39', '+39 (Italy)', '+39 (إيطاليا)'),
  createCountryCode('+40', '+40 (Romania)', '+40 (رومانيا)'),
  createCountryCode('+41', '+41 (Switzerland)', '+41 (سويسرا)'),
  createCountryCode('+43', '+43 (Austria)', '+43 (النمسا)'),
  createCountryCode('+44', '+44 (UK)', '+44 (المملكة المتحدة)'),
  createCountryCode('+45', '+45 (Denmark)', '+45 (الدنمارك)'),
  createCountryCode('+46', '+46 (Sweden)', '+46 (السويد)'),
  createCountryCode('+47', '+47 (Norway)', '+47 (النرويج)'),
  createCountryCode('+48', '+48 (Poland)', '+48 (بولندا)'),
  createCountryCode('+49', '+49 (Germany)', '+49 (ألمانيا)'),
  createCountryCode('+51', '+51 (Peru)', '+51 (بيرو)'),
  createCountryCode('+52', '+52 (Mexico)', '+52 (المكسيك)'),
  createCountryCode('+53', '+53 (Cuba)', '+53 (كوبا)'),
  createCountryCode('+54', '+54 (Argentina)', '+54 (الأرجنتين)'),
  createCountryCode('+55', '+55 (Brazil)', '+55 (البرازيل)'),
  createCountryCode('+56', '+56 (Chile)', '+56 (تشيلي)'),
  createCountryCode('+57', '+57 (Colombia)', '+57 (كولومبيا)'),
  createCountryCode('+58', '+58 (Venezuela)', '+58 (فنزويلا)'),
  createCountryCode('+60', '+60 (Malaysia)', '+60 (ماليزيا)'),
  createCountryCode('+61', '+61 (Australia)', '+61 (أستراليا)'),
  createCountryCode('+62', '+62 (Indonesia)', '+62 (إندونيسيا)'),
  createCountryCode('+63', '+63 (Philippines)', '+63 (الفلبين)'),
  createCountryCode('+64', '+64 (New Zealand)', '+64 (نيوزيلندا)'),
  createCountryCode('+65', '+65 (Singapore)', '+65 (سنغافورة)'),
  createCountryCode('+66', '+66 (Thailand)', '+66 (تايلاند)'),
  createCountryCode('+81', '+81 (Japan)', '+81 (اليابان)'),
  createCountryCode('+82', '+82 (South Korea)', '+82 (كوريا الجنوبية)'),
  createCountryCode('+84', '+84 (Vietnam)', '+84 (فيتنام)'),
  createCountryCode('+86', '+86 (China)', '+86 (الصين)'),
  createCountryCode('+90', '+90 (Turkey)', '+90 (تركيا)'),
  createCountryCode('+91', '+91 (India)', '+91 (الهند)'),
  createCountryCode('+92', '+92 (Pakistan)', '+92 (باكستان)'),
  createCountryCode('+93', '+93 (Afghanistan)', '+93 (أفغانستان)'),
  createCountryCode('+94', '+94 (Sri Lanka)', '+94 (سريلانكا)'),
  createCountryCode('+95', '+95 (Myanmar)', '+95 (ميانمار)'),
  createCountryCode('+212', '+212 (Morocco)', '+212 (المغرب)'),
  createCountryCode('+213', '+213 (Algeria)', '+213 (الجزائر)'),
  createCountryCode('+216', '+216 (Tunisia)', '+216 (تونس)'),
  createCountryCode('+218', '+218 (Libya)', '+218 (ليبيا)'),
  createCountryCode('+220', '+220 (Gambia)', '+220 (غامبيا)'),
  createCountryCode('+221', '+221 (Senegal)', '+221 (السنغال)'),
  createCountryCode('+222', '+222 (Mauritania)', '+222 (موريتانيا)'),
  createCountryCode('+223', '+223 (Mali)', '+223 (مالي)'),
  createCountryCode('+224', '+224 (Guinea)', '+224 (غينيا)'),
  createCountryCode('+225', '+225 (Ivory Coast)', '+225 (ساحل العاج)'),
  createCountryCode('+226', '+226 (Burkina Faso)', '+226 (بوركينا فاسو)'),
  createCountryCode('+227', '+227 (Niger)', '+227 (النيجر)'),
  createCountryCode('+228', '+228 (Togo)', '+228 (توغو)'),
  createCountryCode('+229', '+229 (Benin)', '+229 (بنين)'),
  createCountryCode('+230', '+230 (Mauritius)', '+230 (موريشيوس)'),
  createCountryCode('+231', '+231 (Liberia)', '+231 (ليبيريا)'),
  createCountryCode('+232', '+232 (Sierra Leone)', '+232 (سيراليون)'),
  createCountryCode('+233', '+233 (Ghana)', '+233 (غانا)'),
  createCountryCode('+234', '+234 (Nigeria)', '+234 (نيجيريا)'),
  createCountryCode('+235', '+235 (Chad)', '+235 (تشاد)'),
  createCountryCode('+236', '+236 (Central African Republic)', '+236 (جمهورية أفريقيا الوسطى)'),
  createCountryCode('+237', '+237 (Cameroon)', '+237 (الكاميرون)'),
  createCountryCode('+238', '+238 (Cape Verde)', '+238 (الرأس الأخضر)'),
  createCountryCode('+239', '+239 (São Tomé and Príncipe)', '+239 (ساو تومي وبرينسيب)'),
  createCountryCode('+240', '+240 (Equatorial Guinea)', '+240 (غينيا الاستوائية)'),
  createCountryCode('+241', '+241 (Gabon)', '+241 (الغابون)'),
  createCountryCode('+242', '+242 (Republic of the Congo)', '+242 (جمهورية الكونغو)'),
  createCountryCode('+243', '+243 (DR Congo)', '+243 (جمهورية الكونغو الديمقراطية)'),
  createCountryCode('+244', '+244 (Angola)', '+244 (أنغولا)'),
  createCountryCode('+245', '+245 (Guinea-Bissau)', '+245 (غينيا بيساو)'),
  createCountryCode('+248', '+248 (Seychelles)', '+248 (سيشل)'),
  createCountryCode('+249', '+249 (Sudan)', '+249 (السودان)'),
  createCountryCode('+250', '+250 (Rwanda)', '+250 (رواندا)'),
  createCountryCode('+251', '+251 (Ethiopia)', '+251 (إثيوبيا)'),
  createCountryCode('+252', '+252 (Somalia)', '+252 (الصومال)'),
  createCountryCode('+253', '+253 (Djibouti)', '+253 (جيبوتي)'),
  createCountryCode('+254', '+254 (Kenya)', '+254 (كينيا)'),
  createCountryCode('+255', '+255 (Tanzania)', '+255 (تنزانيا)'),
  createCountryCode('+256', '+256 (Uganda)', '+256 (أوغندا)'),
  createCountryCode('+257', '+257 (Burundi)', '+257 (بوروندي)'),
  createCountryCode('+258', '+258 (Mozambique)', '+258 (موزمبيق)'),
  createCountryCode('+260', '+260 (Zambia)', '+260 (زامبيا)'),
  createCountryCode('+261', '+261 (Madagascar)', '+261 (مدغشقر)'),
  createCountryCode('+263', '+263 (Zimbabwe)', '+263 (زيمبابوي)'),
  createCountryCode('+264', '+264 (Namibia)', '+264 (ناميبيا)'),
  createCountryCode('+265', '+265 (Malawi)', '+265 (مالاوي)'),
  createCountryCode('+266', '+266 (Lesotho)', '+266 (ليسوتو)'),
  createCountryCode('+267', '+267 (Botswana)', '+267 (بوتسوانا)'),
  createCountryCode('+268', '+268 (Eswatini)', '+268 (إسواتيني)'),
  createCountryCode('+269', '+269 (Comoros)', '+269 (جزر القمر)'),
  createCountryCode('+291', '+291 (Eritrea)', '+291 (إريتريا)'),
  createCountryCode('+297', '+297 (Aruba)', '+297 (أروبا)'),
  createCountryCode('+298', '+298 (Faroe Islands)', '+298 (جزر فارو)'),
  createCountryCode('+299', '+299 (Greenland)', '+299 (جرينلاند)'),
  createCountryCode('+350', '+350 (Gibraltar)', '+350 (جبل طارق)'),
  createCountryCode('+351', '+351 (Portugal)', '+351 (البرتغال)'),
  createCountryCode('+352', '+352 (Luxembourg)', '+352 (لوكسمبورغ)'),
  createCountryCode('+353', '+353 (Ireland)', '+353 (أيرلندا)'),
  createCountryCode('+354', '+354 (Iceland)', '+354 (آيسلندا)'),
  createCountryCode('+355', '+355 (Albania)', '+355 (ألبانيا)'),
  createCountryCode('+356', '+356 (Malta)', '+356 (مالطا)'),
  createCountryCode('+357', '+357 (Cyprus)', '+357 (قبرص)'),
  createCountryCode('+358', '+358 (Finland)', '+358 (فنلندا)'),
  createCountryCode('+359', '+359 (Bulgaria)', '+359 (بلغاريا)'),
  createCountryCode('+370', '+370 (Lithuania)', '+370 (ليتوانيا)'),
  createCountryCode('+371', '+371 (Latvia)', '+371 (لاتفيا)'),
  createCountryCode('+372', '+372 (Estonia)', '+372 (إستونيا)'),
  createCountryCode('+373', '+373 (Moldova)', '+373 (مولدوفا)'),
  createCountryCode('+374', '+374 (Armenia)', '+374 (أرمينيا)'),
  createCountryCode('+375', '+375 (Belarus)', '+375 (بيلاروسيا)'),
  createCountryCode('+376', '+376 (Andorra)', '+376 (أندورا)'),
  createCountryCode('+377', '+377 (Monaco)', '+377 (موناكو)'),
  createCountryCode('+378', '+378 (San Marino)', '+378 (سان مارينو)'),
  createCountryCode('+380', '+380 (Ukraine)', '+380 (أوكرانيا)'),
  createCountryCode('+381', '+381 (Serbia)', '+381 (صربيا)'),
  createCountryCode('+382', '+382 (Montenegro)', '+382 (الجبل الأسود)'),
  createCountryCode('+383', '+383 (Kosovo)', '+383 (كوسوفو)'),
  createCountryCode('+385', '+385 (Croatia)', '+385 (كرواتيا)'),
  createCountryCode('+386', '+386 (Slovenia)', '+386 (سلوفينيا)'),
  createCountryCode('+387', '+387 (Bosnia and Herzegovina)', '+387 (البوسنة والهرسك)'),
  createCountryCode('+389', '+389 (North Macedonia)', '+389 (مقدونيا الشمالية)'),
  createCountryCode('+420', '+420 (Czech Republic)', '+420 (جمهورية التشيك)'),
  createCountryCode('+421', '+421 (Slovakia)', '+421 (سلوفاكيا)'),
  createCountryCode('+423', '+423 (Liechtenstein)', '+423 (ليختنشتاين)'),
  createCountryCode('+500', '+500 (Falkland Islands)', '+500 (جزر فوكلاند)'),
  createCountryCode('+501', '+501 (Belize)', '+501 (بليز)'),
  createCountryCode('+502', '+502 (Guatemala)', '+502 (غواتيمالا)'),
  createCountryCode('+503', '+503 (El Salvador)', '+503 (السلفادور)'),
  createCountryCode('+504', '+504 (Honduras)', '+504 (هندوراس)'),
  createCountryCode('+505', '+505 (Nicaragua)', '+505 (نيكاراغوا)'),
  createCountryCode('+506', '+506 (Costa Rica)', '+506 (كوستاريكا)'),
  createCountryCode('+507', '+507 (Panama)', '+507 (بنما)'),
  createCountryCode('+509', '+509 (Haiti)', '+509 (هايتي)'),
  createCountryCode('+590', '+590 (Guadeloupe)', '+590 (غوادلوب)'),
  createCountryCode('+591', '+591 (Bolivia)', '+591 (بوليفيا)'),
  createCountryCode('+592', '+592 (Guyana)', '+592 (غيانا)'),
  createCountryCode('+593', '+593 (Ecuador)', '+593 (الإكوادور)'),
  createCountryCode('+594', '+594 (French Guiana)', '+594 (غويانا الفرنسية)'),
  createCountryCode('+595', '+595 (Paraguay)', '+595 (باراغواي)'),
  createCountryCode('+596', '+596 (Martinique)', '+596 (مارتينيك)'),
  createCountryCode('+597', '+597 (Suriname)', '+597 (سورينام)'),
  createCountryCode('+598', '+598 (Uruguay)', '+598 (أوروغواي)'),
  createCountryCode('+599', '+599 (Curaçao)', '+599 (كوراساو)'),
  createCountryCode('+670', '+670 (East Timor)', '+670 (تيمور الشرقية)'),
  createCountryCode('+672', '+672 (Antarctica)', '+672 (أنتاركتيكا)'),
  createCountryCode('+673', '+673 (Brunei)', '+673 (بروناي)'),
  createCountryCode('+674', '+674 (Nauru)', '+674 (ناورو)'),
  createCountryCode('+675', '+675 (Papua New Guinea)', '+675 (بابوا غينيا الجديدة)'),
  createCountryCode('+676', '+676 (Tonga)', '+676 (تونغا)'),
  createCountryCode('+677', '+677 (Solomon Islands)', '+677 (جزر سليمان)'),
  createCountryCode('+678', '+678 (Vanuatu)', '+678 (فانواتو)'),
  createCountryCode('+679', '+679 (Fiji)', '+679 (فيجي)'),
  createCountryCode('+680', '+680 (Palau)', '+680 (بالاو)'),
  createCountryCode('+681', '+681 (Wallis and Futuna)', '+681 (واليس وفوتونا)'),
  createCountryCode('+682', '+682 (Cook Islands)', '+682 (جزر كوك)'),
  createCountryCode('+685', '+685 (Samoa)', '+685 (ساموا)'),
  createCountryCode('+686', '+686 (Kiribati)', '+686 (كيريباتي)'),
  createCountryCode('+687', '+687 (New Caledonia)', '+687 (كاليدونيا الجديدة)'),
  createCountryCode('+688', '+688 (Tuvalu)', '+688 (توفالو)'),
  createCountryCode('+689', '+689 (French Polynesia)', '+689 (بولينيزيا الفرنسية)'),
  createCountryCode('+691', '+691 (Micronesia)', '+691 (ميكرونيسيا)'),
  createCountryCode('+692', '+692 (Marshall Islands)', '+692 (جزر مارشال)'),
  createCountryCode('+850', '+850 (North Korea)', '+850 (كوريا الشمالية)'),
  createCountryCode('+852', '+852 (Hong Kong)', '+852 (هونغ كونغ)'),
  createCountryCode('+853', '+853 (Macau)', '+853 (ماكاو)'),
  createCountryCode('+855', '+855 (Cambodia)', '+855 (كمبوديا)'),
  createCountryCode('+856', '+856 (Laos)', '+856 (لاوس)'),
  createCountryCode('+880', '+880 (Bangladesh)', '+880 (بنغلاديش)'),
  createCountryCode('+886', '+886 (Taiwan)', '+886 (تايوان)'),
  createCountryCode('+960', '+960 (Maldives)', '+960 (جزر المالديف)'),
  createCountryCode('+961', '+961 (Lebanon)', '+961 (لبنان)'),
  createCountryCode('+962', '+962 (Jordan)', '+962 (الأردن)'),
  createCountryCode('+963', '+963 (Syria)', '+963 (سوريا)'),
  createCountryCode('+964', '+964 (Iraq)', '+964 (العراق)'),
  createCountryCode('+965', '+965 (Kuwait)', '+965 (الكويت)'),
  createCountryCode('+966', '+966 (Saudi Arabia)', '+966 (السعودية)'),
  createCountryCode('+967', '+967 (Yemen)', '+967 (اليمن)'),
  createCountryCode('+968', '+968 (Oman)', '+968 (عمان)'),
  createCountryCode('+970', '+970 (Palestine)', '+970 (فلسطين)'),
  createCountryCode('+971', '+971 (UAE)', '+971 (الإمارات)'),
  createCountryCode('+972', '+972 (Israel)', '+972 (إسرائيل)'),
  createCountryCode('+973', '+973 (Bahrain)', '+973 (البحرين)'),
  createCountryCode('+974', '+974 (Qatar)', '+974 (قطر)'),
  createCountryCode('+975', '+975 (Bhutan)', '+975 (بوتان)'),
  createCountryCode('+976', '+976 (Mongolia)', '+976 (منغوليا)'),
  createCountryCode('+977', '+977 (Nepal)', '+977 (نيبال)'),
  createCountryCode('+992', '+992 (Tajikistan)', '+992 (طاجيكستان)'),
  createCountryCode('+993', '+993 (Turkmenistan)', '+993 (تركمانستان)'),
  createCountryCode('+994', '+994 (Azerbaijan)', '+994 (أذربيجان)'),
  createCountryCode('+995', '+995 (Georgia)', '+995 (جورجيا)'),
  createCountryCode('+996', '+996 (Kyrgyzstan)', '+996 (قيرغيزستان)'),
  createCountryCode('+998', '+998 (Uzbekistan)', '+998 (أوزبكستان)'),
];

// Create Arabic version
export const COUNTRY_CODES_AR = COUNTRY_CODES.map(code => ({
  value: code.value,
  label: code.labelAr,
}));
